import { STATUS_LIST, MY_APPROVE_STATUS_LIST } from './const'

// 审批类型选项
const RISK_TYPE_LIST = [
  { text: '一般审批', value: 1 },
  { text: '高风险审批', value: 2 },
]

export const SEARCH_SCHEMA = [
  {
    itemName: 'companyName',
    label: '企业名称',
    type: 'input',
  },
  {
    itemName: 'companyCode',
    label: '企业ID',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'riskType',
    label: '审批类型',
    type: 'select',
    selectList: RISK_TYPE_LIST,
  },
  {
    itemName: 'business',
    label: '业务类型',
    type: 'select',
    selectList: [],
  },
  {
    itemName: 'region',
    label: '大区/模式',
    type: 'select',
    selectList: [],
  },
  {
    itemName: 'creditManager',
    label: '信用主管',
    type: 'select',
    selectList: [],
  },
]

export const CRM_SEARCH_SCHEMA = [
  {
    itemName: 'companyCode',
    label: '企业ID',
    type: 'input',
  },
  {
    itemName: 'companyName',
    label: '企业名称',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
  {
    itemName: 'status',
    label: '状态',
    type: 'select',
    selectList: STATUS_LIST,
  },
]

export const BATCH_SCHEMA = [
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    allowClear: true,
  },
]

export const AUTO_SEARCH_SCHEMA = [
  {
    itemName: 'companyName',
    label: '企业名称',
    type: 'input',
  },
  {
    itemName: 'companyCode',
    label: '企业ID',
    type: 'input',
  },
  {
    itemName: 'approveRangeDate',
    label: '审批日期',
    type: 'rangePicker',
    allowClear: true,
  },
  {
    itemName: 'status',
    label: '自动审批结果',
    type: 'select',
    selectList: MY_APPROVE_STATUS_LIST,
  },
]